import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useHistory, } from "react-router";
import LoadingComponent from "../../app/layout/LoadingComponent";
import {   Header,  Label,  Segment } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import { Formik, Form } from "formik";
import MyTextInput from "../../app/common/form/MyTextInput";
import { toast, ToastContainer } from 'react-toastify';
import { ExoneracionesDetailFormValues, ExoneracionesListFormValues, ExoneracionesMod, ExoneracionesModFormValues } from "../../app/models/ExoneracionesMod";
import MyTextArea, { MyTextAreaS } from "../../app/common/form/MyTextArea";
import './exoupdate.css'
import { GrTextAlignCenter } from "react-icons/gr";
import MyTextAreaA from "../../app/common/form/MyTextArea";
import { IconButton } from "@material-ui/core";
import { Check } from "@material-ui/icons";
import './exoupdate.css'


interface Props {
    idControl: any
    dpis: any
}


export default observer(function VerExoneraciones (props : Props) {
        
    const [condicion, setCondicion] = useState(false)
    const history = useHistory();
    const [aplica, setAplica]=useState(false);
    const {CCTOperacionStore, CuentaDPIStore} = useStore();
    const {createCCTOperacion, dpiByCodigo,  getTransacciones, TransaccionByCodigo, TransaccionRegistry, personaDPI, kk, inputPersona, CCTCuentaByCodigo} = CCTOperacionStore;

    const {CuotasStore, modalStore} = useStore();  
    const {ExoneracionesStore} = useStore();    

    const {createExoneracionMod, loadIdcontrol, loading, exoneracionDetail, transXCuenta } = ExoneracionesStore; 
    //const {CATCoursesInfo,testing} = CuotasStore;

    const {loadCourses,} = CuotasStore;
    const {loadEditions,} = CuotasStore;
    const {loadTransXTipoCta,} =CuotasStore;
    const {loadExonDetail, updateExoneracionMod} =ExoneracionesStore;

    const [Exoneraciones, setExoneraciones] = useState<ExoneracionesDetailFormValues>(new ExoneracionesDetailFormValues());

    const [ExoneracioneS, setExoneracioneS] = useState<ExoneracionesModFormValues>(new ExoneracionesModFormValues());

    useEffect(() => {
        if (props.idControl) loadIdcontrol(props.idControl).then(Exoneraciones => setExoneraciones(new ExoneracionesDetailFormValues()))
 }, [props.idControl, loadIdcontrol]);
  
       
    const [ExoneracionMod ] = useState<ExoneracionesModFormValues>(new ExoneracionesModFormValues());
    const [ExoneracionesDetail ] = useState<ExoneracionesDetailFormValues>(new ExoneracionesDetailFormValues());

    
    let Nombres : string 
    let actividad: string
    let trans: string 
    let razon: string = ""
    let porcentaje: any = ""
    let codigo: any
    let idalumno: any
    let idaprobado: any
    let idsolicitado: any
    let fechasol: any
    let codigoC: any
    

    

     loadExonDetail(props.idControl)


   
   
let estadoUno:any
const element : HTMLElement = document.getElementById('uno')  as HTMLElement ;
//const element2 : HTMLElement = document.getElementsByName('dos') as unknown as HTMLElement ;


  
  const estadoExo = ()=>{  
   estadoUno= 1
    }

    const estadoExo2 = ()=>{  
        estadoUno= -1
            }
          

              

   if (CuotasStore.loadingInitial) return <LoadingComponent content='Cargando...' />  

    return (

          
            <div className="pagina_formulario">  
           <Segment className="contenedor_formulario">               
                    <Formik 
                            enableReinitialize 
                            initialValues={ExoneracioneS}
                            onSubmit= {values=> handleFormSubmit(values)}>                                                                                    
                                                 
                        <Form className='ui form'  autoComplete='on'>
            
            
             {exoneracionDetail.map((exo)=>{            
                             
            return (
                           <>    
                                <Header size='large' content='Exoneración Autorizada' style={{color:  "#538cbe", fontFamily: "Gotham", textAlign:"center"}}> Exoneración Autorizada <Check style={{ color: "rgb(76, 175, 80)"}}/> </Header>  
                                
                                                <br></br>
                                
                                <div style={{marginBottom: "10px"}} >
                                    <Header size="small" content="Nombre del Alumno" />                                                                                                             
                                    
                                 <MyTextInput placeholder='' name="alumno" type="text" value={exo.alumno}></MyTextInput>                           
                                               
                               
                                    </div>
                                     <br></br>       

                                <div style={{marginBottom: "10px"}} >
                                    <Header size="small" content="Actividad Académica" />
                                    <MyTextInput name='catCodigoCurso' placeholder='' value={exo.nombreCurso}   />
                                    
                                </div><br></br>

                                {/* <div>
                                    <Header size="small" content="Tipo de Transaccion" />
                                                                     
                                    <MySelectInput id="trnsacciones" name='transacciones' placeholder='' options={TiposTransXCta} />
                                    <Button onClick={fun1}></Button>

                                </div>  <br></br> */}
                                <div>
                                    <Header size="small" content="Tipo de Transaccion" />
                                                                     
                                    <MyTextInput  name='cctTiposdeTransaccionId' placeholder=''  value={exo.operacionesDetalle} />
                                </div>  <br></br>                                                                                             
                                                             
                                <div>
                                    <Header size="small" content="Razón de la solicitud" />
                                    <MyTextInput name='razon' placeholder='' value={exo.razon_de_solicitud}/>
                                </div>  <br></br>                                   

                                <div>                                

                                    <div className="porcent"><b>Porcentaje Autorizado:    </b> <h3>{exo.porcentaje_de_solicitud}% </h3><br></br></div>
                                   
                                </div>  <br></br>   

                                 <div>
                                     <Header size="small" content="Comentario" />

                                    <MyTextAreaS name='comentario' placeholder='' rows={3} value={exo.comentario}></MyTextAreaS>

                                     </div>  <br></br>  
                                                                           
                                                                                                           
                                <br></br>  
                                </>                                        
             )}) } 
                   </Form>
                        
                    </Formik>                   
                    
                </Segment>
                
        </div>

    
    )
  
})

function handleFormSubmit(values: ExoneracionesModFormValues): any {
    throw new Error("Function not implemented.");
}
